import { stringify } from 'telejson';

import { AnyDocument, FormDataRequestObject } from '../../../../types';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

const buildDocFormData = (data: FormDataRequestObject<any>): FormData => {
  const formData = new FormData();
  data.files.forEach(({ file, key }) => formData.append(key, file));
  if (data.json) formData.append('json', stringify(data.json));
  return formData;
};

export const postCreateApplicationDoc = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: FormDataRequestObject<any>,
): Promise<NonPaginatedResponse<AnyDocument> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/docs`,
    { data: buildDocFormData(data) },
    { preventDefaultErrorToast: true },
  );
